import { v4 as uuidv4 } from "uuid";

// Utility for generating cryptographically secure IDs
export const generateId = (): string => {
  return uuidv4();
};
